import { FileDtoPascalCase } from '../../models-sparta';

export interface ProspectDataFileDto extends FileDtoPascalCase {
  bResume: boolean;
}
